import { jsonp } from '@ifeng-fe/ui_base';
import md5 from 'md5';
// import { mock } from './mock';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
let requestApiUrl = requestApi;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const getShareDataapi = async () => {
    const getOs = () => {
        const UA = navigator.userAgent.toLocaleLowerCase();

        if (UA.includes('mobile')) {
            if (UA.includes('android')) {
                return 'android';
            }

            return 'ios';
        }

        return 'pc';
    };

    // return mock;

    return await jsonp(requestApiUrl + '/News3HoursList?gv=7.69.0&os='.concat(getOs()));
};

export { getShareDataapi };
